<div class="jumbotron">
    <div class="row user-info-section">
        <div class="col-12 user-info">
            <div class="avatar">
                <space-icon icon='profile' outline='false' class="profile-icon"></space-icon>
            </div>
            <div class="user-data">
                <span class="username">{{userProfile?.firstName}} {{userProfile?.lastName}}</span>
                <span class="user-email">{{userProfile?.email}}</span>
            </div>
        </div>
    </div>
</div>